/*jshint esversion: 11 */

import Panzoom from '@panzoom/panzoom';

// No bundle (e não <script> inline no Blade): o modal de bloqueio de assentos entra na
// página por AJAX do Livewire 3, que insere o HTML via template.innerHTML e nunca executa
// <script> -- o window.initData inline ficava indefinido e o mapa não selecionava nada.
document.addEventListener('alpine:init', () => {
    Alpine.data('blockedSeatsPicker', (selectedSeats) => ({
        selectedSeats,
        tempSelectedSeats: [],
        inited: false,
        onResetSeats: null,

        init() {
            if (this.inited) return;

            this.tempSelectedSeats = [...this.selectedSeats];

            this.$watch('tempSelectedSeats', Alpine.debounce(() => {
                this.selectedSeats = this.tempSelectedSeats;
            }, 300));

            // O clique fica no mapbgzoom (pai que o Livewire não recria): mesmo que ele troque
            // o HTML das cadeiras por dentro, os cliques nas cadeiras novas sobem até aqui.
            this.$refs.mapbgzoom.addEventListener('click', (e) => {
                const el = e.target.closest('.available-seat, .blocked-seat, .selectionable-sector');

                if (!el) return;

                if (el.classList.contains('selectionable-sector')) {
                    this.selectSectorById(el.dataset.mapid || el.id);
                } else {
                    this.selectSeat(el);
                }
            });

            // $this->dispatch('resetSeats') (troca de sessão) chega com S maiúsculo, mas o
            // @resetseats.window do Blade só casa com minúsculo (o HTML minúsculo os atributos):
            // sem este listener a seleção da sessão anterior seguia valendo na nova.
            this.onResetSeats = () => this.resetSeats();
            window.addEventListener('resetSeats', this.onResetSeats);

            this.initPanzoom();

            this.inited = true;
        },

        destroy() {
            window.removeEventListener('resetSeats', this.onResetSeats);
        },

        initPanzoom() {
            // Espera o modal terminar de abrir para medir a altura do mapa.
            setTimeout(() => {
                const elem = this.$refs.mapbgzoom;
                const parent = elem.parentElement;
                let startScale = 1;
                let startY = 0;

                if (elem.offsetHeight > parent.offsetHeight) {
                    startScale = parent.offsetHeight / elem.offsetHeight;
                    startY = 0 - ((elem.offsetHeight - parent.offsetHeight) / 2);
                }

                const panzoom = Panzoom(elem, {
                    maxScale: 5,
                    minScale: startScale,
                    startScale,
                    startY,
                    animate: true,
                    excludeClass: 'seat selectionable-sector',
                });

                parent.addEventListener('wheel', panzoom.zoomWithWheel);
            }, 200);
        },

        selectSeat(el) {
            const seatId = el.id;
            const seatIndex = this.tempSelectedSeats.findIndex((s) => s.id === seatId);

            if (seatIndex === -1) {
                this.tempSelectedSeats.push({
                    index: this.tempSelectedSeats.length,
                    id: seatId,
                });
                el.classList.add('selected');
            } else {
                this.tempSelectedSeats.splice(seatIndex, 1);
                el.classList.remove('selected');
            }
        },

        removeSeat(seatId) {
            this.tempSelectedSeats = this.tempSelectedSeats.filter((s) => s.id !== seatId);

            const domSeat = document.getElementById(seatId);
            if (domSeat) {
                domSeat.classList.remove('selected');
            }

            this.selectedSeats = this.tempSelectedSeats;
        },

        resetSeats() {
            this.tempSelectedSeats = [];
            this.$refs.mapbgzoom.querySelectorAll('.selected').forEach((el) => {
                el.classList.remove('selected');
            });
        },

        selectSectorById(sectorId) {
            this.$refs.mapbgzoom.querySelectorAll('.selectionable-sector').forEach((ele) => {
                if (ele.dataset.mapid === sectorId || ele.id === sectorId) {
                    ele.classList.add('selected');
                } else {
                    ele.classList.remove('selected');
                }
            });
        },
    }));
});
